<button
  class="ssgbtn ripple {{ userClass }}"
  id="{{ name }}"
  name="{{ name }}"
  [disabled]="disabled"
  [hidden]="hidden"
  title="{{ title }}"
  type="{{ buttontype }}"
  [ngClass]="{
    'large-btn': size === 'large',
    'medium-btn': size === 'medium',
    'small-btn': size === 'small',
    fab: appearance === 'fab',
    outline: appearance === 'outline',
    'mini-fab': appearance === 'mini-fab',
    flat: appearance === 'flat',
    disablecolor: disabled
  }">
  <div *ngIf="icon && icon !== ''" class="ssgicon" [class.disableditem]="disabled">
    <i [class.disableditem]="disabled" class="{{ icon }}"></i>
  </div>
  <div *ngIf="label && label !== ''" [class.disableditem]="disabled">
    <span [class.disableditem]="disabled" *ngIf="appearance !== 'fab'">{{ label }}</span>
  </div>
</button>
